var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNoFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 109,
    viewBox: "0 0 124 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.7787 39.5601C71.3987 39.6101 62.8887 39.2301 54.9287 37.0101C46.9687 34.7901 39.9287 30.6301 33.5287 25.7601C29.3387 22.5901 25.5287 20.0701 20.0887 20.4501C14.7688 20.7339 9.68147 22.7219 5.57866 26.1201C-1.34134 32.1201 -0.291343 43.3701 2.46866 51.2601C6.62866 63.1201 19.2887 71.3701 30.0387 76.7401C42.4687 82.9401 56.1187 86.5501 69.8087 88.6201C81.8087 90.4501 97.2087 91.7701 107.609 83.9401C117.159 76.7401 119.779 60.3001 117.439 49.2101C116.871 45.928 115.125 42.9659 112.529 40.8801C105.819 35.9801 95.8187 39.2601 88.2787 39.4201C85.4787 39.4801 82.6387 39.5501 79.7787 39.5601Z",
    fill: "#3D3F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.918 0.75V5.06",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7686 2.8999H41.0686",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.498 86.46V90.76",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.349 88.6099H122.649",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42922 67.8899C6.97046 67.8899 7.40922 67.4512 7.40922 66.9099C7.40922 66.3687 6.97046 65.9299 6.42922 65.9299C5.88798 65.9299 5.44922 66.3687 5.44922 66.9099C5.44922 67.4512 5.88798 67.8899 6.42922 67.8899Z",
    fill: "#5E628C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8687 5.19999C90.4099 5.19999 90.8487 4.76123 90.8487 4.21999C90.8487 3.67875 90.4099 3.23999 89.8687 3.23999C89.3274 3.23999 88.8887 3.67875 88.8887 4.21999C88.8887 4.76123 89.3274 5.19999 89.8687 5.19999Z",
    fill: "#5E628C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7088 108.06C82.9776 108.06 99.4088 107.039 99.4088 105.78C99.4088 104.521 82.9776 103.5 62.7088 103.5C42.4399 103.5 26.0088 104.521 26.0088 105.78C26.0088 107.039 42.4399 108.06 62.7088 108.06Z",
    fill: "#3D3F63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4384 12.4299H87.7384C89.0645 12.4299 90.3363 12.9567 91.2739 13.8944C92.2116 14.8321 92.7384 16.1039 92.7384 17.4299V80.8399C92.7384 82.166 92.2116 83.4378 91.2739 84.3755C90.3363 85.3131 89.0645 85.8399 87.7384 85.8399H27.6084C26.2823 85.8399 25.0105 85.3131 24.0729 84.3755C23.1352 83.4378 22.6084 82.166 22.6084 80.8399V24.3799L34.4384 12.4299Z",
    fill: "#5E628C",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4991 43.3398H37.5391V86.4598H92.4991V43.3398Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6084 24.3799H32.2984C32.5803 24.3799 32.8594 24.3243 33.1197 24.2161C33.38 24.1079 33.6163 23.9494 33.8152 23.7496C34.014 23.5498 34.1714 23.3127 34.2784 23.0519C34.3853 22.7912 34.4397 22.5118 34.4384 22.2299V12.4299L22.6084 24.3799Z",
    fill: "#5E628C",
    stroke: "#3D3F63",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2291 29.5601H37.8691C35.7538 29.5601 34.0391 31.2748 34.0391 33.3901V45.0201C34.0391 47.1353 35.7538 48.8501 37.8691 48.8501H92.2291C94.3443 48.8501 96.0591 47.1353 96.0591 45.0201V33.3901C96.0591 31.2748 94.3443 29.5601 92.2291 29.5601Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5988 42.5699C46.4434 42.5699 47.9388 41.0745 47.9388 39.2299C47.9388 37.3853 46.4434 35.8899 44.5988 35.8899C42.7542 35.8899 41.2588 37.3853 41.2588 39.2299C41.2588 41.0745 42.7542 42.5699 44.5988 42.5699Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0988 42.5699C56.9434 42.5699 58.4388 41.0745 58.4388 39.2299C58.4388 37.3853 56.9434 35.8899 55.0988 35.8899C53.2542 35.8899 51.7588 37.3853 51.7588 39.2299C51.7588 41.0745 53.2542 42.5699 55.0988 42.5699Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.588 42.5699C67.4327 42.5699 68.928 41.0745 68.928 39.2299C68.928 37.3853 67.4327 35.8899 65.588 35.8899C63.7434 35.8899 62.248 37.3853 62.248 39.2299C62.248 41.0745 63.7434 42.5699 65.588 42.5699Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2291 50.95H37.8691C35.7538 50.95 34.0391 52.6647 34.0391 54.7799V66.41C34.0391 68.5252 35.7538 70.24 37.8691 70.24H92.2291C94.3443 70.24 96.0591 68.5252 96.0591 66.41V54.7799C96.0591 52.6647 94.3443 50.95 92.2291 50.95Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5988 63.9598C46.4434 63.9598 47.9388 62.4644 47.9388 60.6198C47.9388 58.7752 46.4434 57.2798 44.5988 57.2798C42.7542 57.2798 41.2588 58.7752 41.2588 60.6198C41.2588 62.4644 42.7542 63.9598 44.5988 63.9598Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0988 63.9598C56.9434 63.9598 58.4388 62.4644 58.4388 60.6198C58.4388 58.7752 56.9434 57.2798 55.0988 57.2798C53.2542 57.2798 51.7588 58.7752 51.7588 60.6198C51.7588 62.4644 53.2542 63.9598 55.0988 63.9598Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.588 63.9598C67.4327 63.9598 68.928 62.4644 68.928 60.6198C68.928 58.7752 67.4327 57.2798 65.588 57.2798C63.7434 57.2798 62.248 58.7752 62.248 60.6198C62.248 62.4644 63.7434 63.9598 65.588 63.9598Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2291 72.3301H37.8691C35.7538 72.3301 34.0391 74.0448 34.0391 76.1601V87.7901C34.0391 89.9053 35.7538 91.6201 37.8691 91.6201H92.2291C94.3443 91.6201 96.0591 89.9053 96.0591 87.7901V76.1601C96.0591 74.0448 94.3443 72.3301 92.2291 72.3301Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5988 85.3399C46.4434 85.3399 47.9388 83.8445 47.9388 81.9999C47.9388 80.1553 46.4434 78.6599 44.5988 78.6599C42.7542 78.6599 41.2588 80.1553 41.2588 81.9999C41.2588 83.8445 42.7542 85.3399 44.5988 85.3399Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0988 85.3399C56.9434 85.3399 58.4388 83.8445 58.4388 81.9999C58.4388 80.1553 56.9434 78.6599 55.0988 78.6599C53.2542 78.6599 51.7588 80.1553 51.7588 81.9999C51.7588 83.8445 53.2542 85.3399 55.0988 85.3399Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.588 85.3399C67.4327 85.3399 68.928 83.8445 68.928 81.9999C68.928 80.1553 67.4327 78.6599 65.588 78.6599C63.7434 78.6599 62.248 80.1553 62.248 81.9999C62.248 83.8445 63.7434 85.3399 65.588 85.3399Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23C75 21.5999 75 20.8998 75.2725 20.365C75.5122 19.8946 75.8946 19.5122 76.365 19.2725C76.8998 19 77.5999 19 79 19H116C117.4 19 118.1 19 118.635 19.2725C119.106 19.5122 119.488 19.8946 119.728 20.365C120 20.8998 120 21.5999 120 23V27.3431C120 27.9546 120 28.2604 119.931 28.5481C119.87 28.8032 119.769 29.047 119.632 29.2707C119.477 29.523 119.261 29.7392 118.829 30.1716L103.672 45.3285C103.239 45.7607 103.023 45.977 102.868 46.2292C102.731 46.453 102.63 46.6968 102.569 46.952C102.5 47.2398 102.5 47.5455 102.5 48.1567V54L92.5 64V48.1567C92.5 47.5455 92.5 47.2398 92.4309 46.952C92.3697 46.6968 92.2687 46.453 92.1316 46.2292C91.977 45.977 91.7608 45.7607 91.3284 45.3285L76.1716 30.1716C75.7392 29.7392 75.523 29.523 75.3684 29.2707C75.2313 29.047 75.1303 28.8032 75.0691 28.5481C75 28.2604 75 27.9546 75 27.3431V23Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoFilter);
export default __webpack_public_path__ + "static/media/EmptyState-NoFilter.08575104138f46d37a1bb7e439c9981f.svg";
export { ForwardRef as ReactComponent };